module.exports = __webpack_public_path__ + "static/img/6.321f04e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/zh/6.png
// module id = gE7g
// module chunks = 0